import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import FaEdit from 'react-icons/lib/fa/edit'
import moment from 'moment'

export default class Actions extends React.Component {
  static propTypes = {
    verifyDocument: PropTypes.object
  }

  state = {}

  renderInformation() {
    const activities = this.props.verifyDocument.activities || []
    return activities.map(activity => {
      return (
        <div
          className="row"
          key={activity.date}
          style={{
            borderBottom: '1px solid #e6ebf1',
            paddingBottom: 5,
            paddingTop: 5
          }}
        >
          <div className="col-xs-12 col-md-2">
            <b>{activity.action}</b>
          </div>
          <div className="col-xs-12 start-xs col-md-3 center-md">
            {moment(activity.date).format('DD/MM/YYYY HH:mm')}
          </div>
          <div className="col-xs-12 col-md-5">{activity.userEmail}</div>
          <div className="col-xs-12 col-md-2">{activity.ip}</div>
        </div>
      )
    })
  }

  render() {
    if (!this.props.verifyDocument) return
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className={styles.Icon}>
              <FaEdit size={30} />
            </div>
            <div className={styles.Title}>
              <h3>Acciones</h3>
            </div>
          </div>
        </div>
        <div className="content">{this.renderInformation()}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/PubDocumentVerify/DocVerifier/Verify/Actions/index.js